<ng-container *ngIf="contentWidget">
	<div class="obg-m-content-widget-image">
		<obg-lazy-image
			*ngIf="contentWidget.image"
			[src]="contentWidget.image.url"
			[alt]="contentWidget.image.altText"
		></obg-lazy-image>
	</div>
	<div class="obg-m-content-widget-data" [ngClass]="{ 'obg-m-content-widget-data-seo': contentWidget.titleH3 }">
		<h1 *ngIf="contentWidget.titleH1" class="obg-m-content-widget-header-1">{{ contentWidget.titleH1 }}</h1>
		<h2 *ngIf="contentWidget.title" class="obg-m-content-widget-header-1">{{ contentWidget.title }}</h2>
		<p class="obg-m-content-widget-description" [innerHTML]="contentWidget.description"></p>
		<h3 *ngIf="contentWidget.titleH3" class="obg-m-content-widget-header-2">{{ contentWidget.titleH3 }}</h3>
		<p
			class="obg-m-content-widget-description"
			*ngIf="contentWidget.additionalDescription"
			[innerHTML]="contentWidget.additionalDescription"
		></p>
		<div *ngIf="contentWidget.ctaUrl?.url">
			<a [href]="contentWidget.ctaUrl?.url" mat-flat-button color="primary">{{ contentWidget?.ctaLabel }}</a>
		</div>
	</div>
</ng-container>
